import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=09ec36a0&"
import script from "./signUp.vue?vue&type=script&lang=ts&"
export * from "./signUp.vue?vue&type=script&lang=ts&"
import style0 from "./signUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports